import { Component, OnInit } from '@angular/core';
import { NoticeService, Notice } from '../notice/notice.service';


@Component({
    selector: 'mobile-notice',
    templateUrl: 'notice.component.html',
    providers: [NoticeService]
})
export class MobileNoticeComponent implements OnInit {

    noticeList: Notice[];
    totalCount: number;

    constructor(
        private noticeService: NoticeService
    ) {  }
 

    ngOnInit() {
        this.getNoticeList();
    }


    getNoticeList() {
        this.noticeService.getNoticeList(1, false)
            .take(1).subscribe(
                data => {
                    this.noticeList = data['results'];
                    this.totalCount = data['count'];
                }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/mobile/notice.component.ts